/**
 * Shared helper: turn an in-app note notification into prefill props for
 * ActivityQuickAddModal ("Me le rappeler" on a notification).
 * Used by NoteNotificationDropdown and MyNotificationsView.
 *
 * @param {Object} notif - a `noteNotifications` document
 * @param {Function} t - i18next translate function
 * @returns {{defaultTitle: string, defaultNote: string,
 *            linkedEntity: Object, sourceRef: Object}}
 */
export function buildActivityPrefillFromNotification(notif, t) {
  const author = notif.noteAuthorName || t("myNotifications.unknownAuthor");
  const content = (notif.noteContent || "").trim();

  return {
    defaultTitle: t("activities.fromNote.defaultTitle", { author }),
    defaultNote: content.length > 300 ? `${content.slice(0, 300)}…` : content,
    linkedEntity: {
      type: "note",
      id: notif.noteId || null,
      name: notif.sectorName
        ? `${t("activities.fromNote.entityName")} — ${notif.sectorName}`
        : t("activities.fromNote.entityName"),
      actionUrl: notif.actionUrl || null,
      // Entité qui porte la note : le rappel ouvre ses notes, pas tout le secteur.
      destinationType: notif.destinationType || null,
      destinationId: notif.destinationId || null,
    },
    sourceRef: {
      type: "noteNotification",
      id: notif.id,
    },
  };
}

export default buildActivityPrefillFromNotification;
